import { DataTypeProvider } from "@devexpress/dx-react-grid"
import { Box, Chip, IconButton, Tooltip } from "@mui/material"
import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom"
import TimeAgo from 'react-timeago'
import { useParams, useLocation, useNavigate } from "react-router-dom";
import AuthService from '../../services/auth-service';
import notify from 'devextreme/ui/notify';
import ComputerListViewLicFormDialog from './form_dialog/ComputerListViewLicFormDialog'
import ComputerListBuildLicFormDialog from './form_dialog/ComputerListBuildLicFormDialog'
import ComputerListAutoLicFormDialog from './form_dialog/ComputerListAutoLicFormDialog'
import ResellerSearchList from '../ResellerSearchList'

import EditIcon from '@mui/icons-material/Edit';
import BuildIcon from '@mui/icons-material/Build';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AutorenewIcon from '@mui/icons-material/Autorenew';

// ************************************************************

const KeygenFormatter = ({ value }) => {
  if (value === 0)
    return <>{value}</>
  return (
    <b style={{ color: 'red' }}>    
      {value}
    </b>
  )
}
export const KeygenTypeProvider = props => <DataTypeProvider formatterComponent={KeygenFormatter} {...props} />

const DateFormatter = ({ value }) => {
  value = (!value) ? '0000-00-00 00:00:00' : value.trim()
  if (value === "0000-00-00 00:00:00")
    return <></>
  return (
    <b style={{ color: 'darkblue' }}>    
      <TimeAgo date={value} />
    </b>
  )
}
export const DateTypeProvider = props => <DataTypeProvider formatterComponent={DateFormatter} {...props} />

const UserCodeFormatter = ({ value }) => {
  return (
    <Box sx={{ fontFamily: 'Monospace', fontSize: 10, m: 1 }}>
      {value}
    </Box>
  )
}
export const UserCodeTypeProvider = props => <DataTypeProvider formatterComponent={UserCodeFormatter} {...props} />

const SwNameFormatter = ({ row }) => {
  row.l_sw_name = (!row.l_sw_name) ? '' : row.l_sw_name.trim()
  row.program_name = (!row.program_name) ? '' : row.program_name.trim()

  if (row.l_sw_name == '') 
    if (row.program_name == '') 
      return <></>

  if (row.l_sw_name == '') 
    return (
      <Box sx={{ fontWeight: 'bold', fontFamily: 'Monospace', fontSize: 12, p: 1, m: 0.5, color: 'error.main' }}>
        {row.program_name}
      </Box>
    )
    
  if (row.program_name == '') 
    return (
      <Box sx={{ fontWeight: 'bold', fontFamily: 'Monospace', fontSize: 12, p: 1, m: 0.5, color: 'error.main' }}>
        {row.l_sw_name}
      </Box>
    )
  
  if (row.l_sw_name != row.program_name) 
    return (
      <Box sx={{ fontWeight: 'bold', fontFamily: 'Monospace', fontSize: 12, p: 1, m: 0.5, bgcolor: 'warning.main' }}>
        {row.program_name}
      </Box>
    )
  
  return (
    <Box sx={{ fontWeight: 'bold', fontFamily: 'Monospace', fontSize: 12, p: 1, m: 0.5, color: 'text.primary' }}>
      {row.l_sw_name}
    </Box>
  )
}
export const SwNameTypeProvider = props => <DataTypeProvider formatterComponent={SwNameFormatter} {...props} />

const SwVerFormatter = ({ row }) => {
  row.l_sw_ver = (!row.l_sw_ver) ? '' : row.l_sw_ver.trim()
  row.program_name = (!row.program_name) ? '' : row.program_name.trim()

  if (row.l_sw_ver == '') 
    return <></>

  if (row.program_name == '') 
    return (
      <Box sx={{ fontWeight: 'bold', fontFamily: 'Monospace', fontSize: 12, p: 1, m: 0.5, color: 'error.main' }}>
        {row.l_sw_ver}
      </Box>
    )
  
  return (
    <Box sx={{ fontWeight: 'bold', fontFamily: 'Monospace', fontSize: 12, p: 1, m: 0.5, color: 'text.primary' }}>
      {row.l_sw_ver}
    </Box>
  )
}
export const SwVerTypeProvider = props => <DataTypeProvider formatterComponent={SwVerFormatter} {...props} />

const RowNumFormatter = ({ row }) => {
  if (row.u_is_admin && row.u_is_reseller) return <Chip label={row.row_num} size="small" color="error" />
  if (row.u_is_admin) return <Chip label={row.row_num} size="small" color="warning" />
  if (row.u_is_reseller) return <Chip label={row.row_num} size="small" color="info" />
  return <Chip label={row.row_num} size="small" variant="outlined" />  
}
export const RowNumTypeProvider = props => <DataTypeProvider formatterComponent={RowNumFormatter} {...props} />

const UserTypeFormatter = ({ row }) => {
  return (
    <div style={{ display: 'flex', gap: '4px' }}>
      <Tooltip title="Admin">
        {row.u_is_admin ? (
          <Chip label="A" color="error" />
        ) : (
          <Chip label="A" variant="outlined" disabled />
        )}
      </Tooltip>
      <Tooltip title="Reseller">
        {row.u_is_reseller ? (
          <Chip label="R" color="warning" />
        ) : (
          <Chip label="R" variant="outlined" disabled />
        )}
      </Tooltip>
      <Tooltip title="Gas Specialist">
        {row.u_is_gas_specialist ? (
          <Chip label="G" color="success" />
        ) : (
          <Chip label="G" variant="outlined" disabled />
        )}
      </Tooltip>
    </div>
  )
}
export const UserTypeTypeProvider = props => <DataTypeProvider formatterComponent={UserTypeFormatter} {...props} />

const IsAdminFormatter = ({ value }) => {
  if (value) return <Chip label="1" color="warning" />
  return <Chip label="0" variant="outlined" />  
}
export const IsAdminTypeProvider = props => <DataTypeProvider formatterComponent={IsAdminFormatter} {...props} />

const IsResellerFormatter = ({ value }) => {
  if (value) return <Chip label="1" color="info" />
  return <Chip label="0" variant="outlined" />  
}
export const IsResellerTypeProvider = props => <DataTypeProvider formatterComponent={IsResellerFormatter} {...props} />

const AccessoWebFormatter = ({ value }) => {
  if (!value) return <Chip label="0" color="warning" />
  return <Chip label="1" variant="outlined" color="success" />  
}
export const AccessoWebTypeProvider = props => <DataTypeProvider formatterComponent={AccessoWebFormatter} {...props} />

const PasswordHashFormatter = ({ value }) => {
  if (!value) return <Chip label="0" color="warning"  />
  return <Chip label="1" color="success" variant="outlined" />  
}
export const PasswordHashTypeProvider = props => <DataTypeProvider formatterComponent={PasswordHashFormatter} {...props} />

const UsernameFormatter = ({ row }) => {
  return <Link to={"/service/user/details/" + row.u_id}>{row.u_username}</Link>
}
export const UsernameTypeProvider = props => (
  <DataTypeProvider
    formatterComponent={UsernameFormatter}
    availableFilterOperations={['equal', 'contains', 'startsWith', 'endsWith']}
    {...props}
  />
);

export const ResellerFormDialog = ({ open, onClose, onSubmit, userId, resellersRows }) => {
  const [selectedReseller, setSelectedReseller] = useState('')
  useEffect(() => {
    if (open) {
      const selected = resellersRows.find(reseller => reseller.id === userId)
      setSelectedReseller(selected ? selected.id : '')
    }
  }, [open, userId, resellersRows])
  const handleSubmit = () => {
    onSubmit(selectedReseller)
  }
  return (
    <Dialog open={open} onClose={onClose} fullWidth={true} maxWidth="xl">
      <DialogTitle>EDIT RESELLER</DialogTitle>
      <DialogContent>
        {open && <ResellerSearchList rows={resellersRows} selectedId={selectedReseller} onSelect={setSelectedReseller} />}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSubmit} color="primary" disabled={!resellersRows.some(row => row.id === selectedReseller)}>Submit</Button>
      </DialogActions>
    </Dialog>
  )
}
const ResellerUsernameFormatter = ({ row, user, resellersRows, updateTableRows }) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => { setOpen(true); }
  const handleClose = () => { setOpen(false); }
  const handleSubmit = (resellerId) => {
    AuthService.setComputerReseller(row.id, resellerId).then(() => {
      updateTableRows()
      setOpen(false)
    })
  }
  if (!user.is_admin) return <>{row.reseller_username}</>
  
  var to_fix = false
  var btn_color = "primary"  
  var tip_msg = "EDIT"
  if (row.reseller_id === -1) {
    // visualizzo solo EDIT --> un reseller ci vuole
    btn_color =  row.u_is_reseller ? "warning" : "error"
    tip_msg = row.u_is_reseller ? "EDIT: this is the computer of a reseller" : "EDIT: this user previously was a reseller"
  } else if (!resellersRows.some(reseller => reseller.id === row.reseller_id)) {
    // reseller non esiste
    to_fix = true
    btn_color = "error"
    tip_msg = "FIX: reseller not found"
  }
  
  return (
<>
    <Tooltip title={tip_msg}>
      <Button 
        color={btn_color}
        size="small" 
        variant={to_fix ? "outlined" : "contained"}
        onClick={handleOpen}
      >
        {to_fix ? <BuildIcon /> : <EditOutlinedIcon />}
      </Button>
    </Tooltip>
    {row.reseller_id !== -1 && (<>
      {' '}
      <Link
        to={"/service/user/details/" + row.reseller_id}
        style={to_fix ? { color: 'red' } : {}} >
        {row.reseller_username}
      </Link> 
    </>)}
    <ResellerFormDialog 
      open={open} 
      onClose={handleClose} 
      onSubmit={handleSubmit} 
      userId={row.reseller_id} 
      resellersRows={resellersRows} />
  </>
  )
}
export const ResellerUsernameTypeProvider = props => <DataTypeProvider 
  formatterComponent={
    (rowProps) => <ResellerUsernameFormatter 
      {...rowProps} 
      user={props.user}
      resellersRows={props.resellersRows}
      updateTableRows={props.updateTableRows} />
    } {...props} />

// ************************************************************
// ************************************************************
// ************************************************************

export const ViewLicFormatter = (props) => {
  const [open, setOpen] = React.useState(false)
  const { user_code } = useParams()
  const handleOpen = () => { setOpen(true) }
  const handleClose = () => {
    setOpen(false);
    // Remove "/license" from URL if present
    if (location.pathname.endsWith('/license')) {
      navigate(location.pathname.replace(/\/license$/, ''));
    }
  };
  const location = useLocation()
  const navigate = useNavigate();

  React.useEffect(() => {
    if (location.pathname.endsWith('/license') && user_code === props.row.user_code) {
      setOpen(true)
    }
  }, [location, user_code, props.row.user_code])

  var only_dates = !(props.user.is_admin || props.user.is_reseller)
  return (
    <>
  <ComputerListViewLicFormDialog 
    open={open} 
    only_dates={only_dates}
    lic_file={props.row.lic_file}
    user_code={props.row.user_code}
    onClickClose={handleClose} />
    
  {props.row.has_license ? (
    <Tooltip title="VIEW LICENSE">
      <Button size="small" variant="contained" onClick={handleOpen}>
        <VisibilityIcon />
      </Button>
    </Tooltip>
  ) : (
    <Button disabled size="small" variant="contained">
      <VisibilityIcon />
    </Button>
  )}
</>
  )
} 

export const BuildLicFormatter = (props) => {  
  const notifySomething = (message, type="success") => {
    notify({
      message: message,
      position: {
        my: 'center top',
        at: 'center top',
      },
    }, type, 3000)
  }
  const [open, setOpen] = React.useState(false)
  const [spin, setSpin] = React.useState(false)
  const handleOpen = () => { 
    ///console.log(props.programList)
    setOpen(true) 
  }
  const handleClose = () => { setOpen(false) }
  const handleSubmit = (e) => {
    //e = {
    //  userLevel,
    //  customConfig,
    //  endDate,
    //  programSelector,
    //}
    var user_data = {
      user_code: row.user_code,
      custom_config: e.customConfig,
      user_level: e.userLevel,
      program_selector: e.programSelector,
      end_date: e.endDate,
      disable_rsa: false
    }
    
    console.log(user_data)
    setSpin(true)

    AuthService.buildLicense(user_data).then(data => {
      if (data.is_valid) {
        notifySomething("License sent!")     
        props.dataChanged()     
      } else {
        console.log(data.message)
        notifySomething(data.message, "error")
      }
      setSpin(false)
      setOpen(false)
    }).catch(e => {
      console.log(e)
      notifySomething(e, "error")
      setSpin(false)
      setOpen(false)
    })
  }
  
  var row = props.row
  row.l_sw_ver = (!row.l_sw_ver) ? '' : row.l_sw_ver.trim()
  row.l_sw_name = (!row.l_sw_name) ? '' : row.l_sw_name.trim()
  row.program_name = (!row.program_name) ? '' : row.program_name.trim()
  
  var sw_name = ''
  if (row.l_sw_name != '') 
    sw_name = row.l_sw_name
  else if (row.program_name != '') 
    sw_name = row.program_name
    
  var sw_ver = row.l_sw_ver
  //console.log(props)

  return (
    <>
      <ComputerListBuildLicFormDialog 
        open={open} 
        spin={spin}
        id={row.id}
        user_code={row.user_code}
        admin_comp={row.u_is_admin}
        is_admin={props.user.is_admin}
        user_id={props.user.id}
        reseller_programs={props.user.reseller_programs}
        custom_config_en={props.user.custom_config_en}
        sw_name={sw_name}
        sw_ver={sw_ver}
        programList={props.programList}
        onClickClose={handleClose} 
        onClickSubmit={handleSubmit} />
      <Tooltip title="BUILD LICENSE">
        <Button size="small" variant="contained" onClick={handleOpen}>
          <BuildIcon />
        </Button>
      </Tooltip>
    </>
  )  
}

export const AutoLicFormatter = (props) => {  
  const notifySomething = (message, type="success") => {
    notify({
      message: message,
      position: {
        my: 'center top',
        at: 'center top',
      },
    }, type, 3000)
  }
  const [open, setOpen] = React.useState(false)
  const [spin, setSpin] = React.useState(false)
  const handleOpen = () => { setOpen(true) }
  const handleClose = () => { setOpen(false) }
  const handleSubmit = (e) => {
    // console.log(row.user_code)
    // return
    var user_data = {
      user_code: row.user_code,
      custom_config: e.customConfig,
      user_level: e.userLevel,
      kill: e.kill,
      auto_gen: e.autoGen,
    }    
    //console.log(user_data)
    setSpin(true)
    //setTimeout(() => {
    //  setSpin(false)
    //  setOpen(false)
    //}, 3000)    
    AuthService.updateComputerAutoLicense(user_data).then(data => {
      if (data.is_valid) {
        notifySomething("Auto license updated!")    
        props.dataChanged()      
      } else {
        console.log(data.message)
        notifySomething(data.message, "error")
      }
      setSpin(false)
      setOpen(false)
    }).catch(e => {
      console.log(e)
      notifySomething(e, "error")
      setSpin(false)
      setOpen(false)
    })
  }
  
  var row = props.row
    
  row.l_sw_ver = (!row.l_sw_ver) ? '' : row.l_sw_ver.trim()
  row.l_sw_name = (!row.l_sw_name) ? '' : row.l_sw_name.trim()
  row.program_name = (!row.program_name) ? '' : row.program_name.trim()
  
  var sw_name = ''
  if (row.l_sw_name !== '') 
    sw_name = row.l_sw_name
  else if (row.program_name !== '') 
    sw_name = row.program_name
    
  var sw_ver = row.l_sw_ver
  
  var btn_color = "primary"
  if (row.auto_license_ready === 2) 
    btn_color = "warning"

  return (
    <>
      <ComputerListAutoLicFormDialog 
        open={open} 
        spin={spin}
        id={row.id}
        user_code={row.user_code}
        is_admin={props.user.is_admin}        
        reseller_programs={props.user.reseller_programs}
        custom_config_en={props.user.custom_config_en}
        auto_license={{
          _val: row.auto_license,
          config: row.auto_license_config,
          level: row.auto_license_level,
          ready: row.auto_license_ready,
        }}
        sw_name={sw_name}
        sw_ver={sw_ver}
        programList={props.programList}
        onClickClose={handleClose} 
        onClickSubmit={handleSubmit} />
      
      {(!row.auto_license_ready || sw_name === '') ? (
        // <Tooltip title="AUTO LICENSE">
          <Button 
            disabled
            size="small" 
            variant="contained" 
            color="primary">
            <AutorenewIcon />
          </Button>  
        // </Tooltip>
      ) : (
        <Tooltip title="AUTO LICENSE">
          <Button 
            size="small" 
            variant="contained" 
            color={btn_color} 
            onClick={handleOpen}>
            <AutorenewIcon />
          </Button>  
        </Tooltip>
)}
    </>
  )  
}

export const LicOptionsFormatter = (props) => {
  const { row, user, programList, dataChanged } = props
  const only_view = !(user.is_admin || user.is_reseller)
  return (
    <Box component="span" display="flex" alignItems="center" gap={0.5}>
      <ViewLicFormatter 
        row={row} 
        user={user} />
      {!only_view && (
        <>
          <BuildLicFormatter
            row={row}
            user={user}
            programList={programList}
            dataChanged={dataChanged} />
          <AutoLicFormatter
            row={row}
            user={user}
            programList={programList}
            dataChanged={dataChanged} />
        </>
      )}
    </Box>
  )
}

// ************************************************************
// ************************************************************
// ************************************************************

export default class ComputerListTableProps {
  getTableColumns(user) {
    var lvl = user.is_admin ? 2 : user.is_reseller ? 1 : 0
    return [
      { name: 'row_num', title: '#', getCellValue: row => row.row_num },
      //{ name: 'id', title: 'Id', getCellValue: row => row.id },
      { name: 'insert_date', title: 'Insert', getCellValue: row => row.insert_date },
      { name: 'user_code', title: 'User code', getCellValue: row => row.user_code },
      { name: 'l_sw_name', title: 'Name', getCellValue: row => row.l_sw_name },
      { name: 'l_sw_ver', title: 'Version', getCellValue: row => row.l_sw_ver },
      ...(lvl==2?[{ name: 'program_name', title: ' ', getCellValue: row => row.program_name }]:[]),
      //{ name: 'u_email', title: 'Email', getCellValue: row => row.u_email },
      ...(lvl>0?[{ name: 'u_username', title: 'Username', getCellValue: row => row.u_username }]:[]),
      ...(lvl>0?[{ name: 'l_date_insert', title: 'Activity', getCellValue: row => row.l_date_insert }]:[]),
      { name: 'l_geo', title: 'Geo', getCellValue: row => row.l_geo },
      //{ name: 'l_ip_addr', title: 'Ip', getCellValue: row => row.l_ip_addr },
      { name: 'lic_update', title: 'License', getCellValue: row => row.lic_update },
      { name: 'lic_options', title: 'Options', getCellValue: row => row.lic_options },
      ...(lvl>0?[{ name: 'u_user_type', title: 'User type', getCellValue: row => row.u_user_type }]:[]),
      // ...(lvl>0?[{ name: 'u_is_admin', title: 'A', getCellValue: row => row.u_is_admin }]:[]),
      // ...(lvl>0?[{ name: 'u_is_reseller', title: 'R', getCellValue: row => row.u_is_reseller }]:[]),
      // ...(lvl>0?[{ name: 'u_is_gas_specialist', title: 'G', getCellValue: row => row.u_is_gas_specialist }]:[]),
      { name: 'reseller_username', title: 'Reseller', getCellValue: row => row.reseller_username },
    ]
  }
  getTableColumnWidths(user) {
    if (user === null) {
      return [
        { columnName: 'row_num', width: 95 },
        { columnName: 'id', width: 0 },
        { columnName: 'insert_date', width: 110 },
        { columnName: 'user_code', width: /*400 120 */ 395 },
        { columnName: 'l_sw_name', width: 145 },
        { columnName: 'l_sw_ver', width: 90 },
        { columnName: 'program_name', width: 0 },
        { columnName: 'u_email', width: 140 },
        { columnName: 'u_username', width: 140 },
        { columnName: 'l_date_insert', width: 110 },
        { columnName: 'l_ip_addr', width: 0 },
        { columnName: 'lic_update', width: 110 },
        { columnName: 'lic_options', width: 0 },
        { columnName: 'u_user_type', width: 100 },
        // { columnName: 'u_is_admin', width: 80 },
        // { columnName: 'u_is_reseller', width: 80 },
        // { columnName: 'u_is_gas_specialist', width: 80 },
        { columnName: 'reseller_username', width: 200 },
        { columnName: 'l_geo', width: 120 },
      ]
    }
    var lvl = user.is_admin ? 2 : user.is_reseller ? 1 : 0
    return [
      { columnName: 'row_num', width: 95 },
      { columnName: 'id', width: 0 },
      { columnName: 'insert_date', width: 110 },
      { columnName: 'user_code', width: /*400 120 */ 395 },
      { columnName: 'l_sw_name', width: 145 },
      { columnName: 'l_sw_ver', width: 90 },
      { columnName: 'program_name', width: 0 },
      { columnName: 'u_email', width: 140 },
      { columnName: 'u_username', width: 140 },
      { columnName: 'l_date_insert', width: 110 },
      { columnName: 'l_ip_addr', width: 0 },
      { columnName: 'lic_update', width: 110 },
      { columnName: 'lic_options', width: lvl>0 ? 220 : 110 },
      { columnName: 'u_user_type', width: 120 },
      // { columnName: 'u_is_admin', width: 70 },
      // { columnName: 'u_is_reseller', width: 70 },
      // { columnName: 'u_is_gas_specialist', width: 70 },
      { columnName: 'reseller_username', width: 200 },
      { columnName: 'l_geo', width: 120 },
    ]
  }
  getTableColumnExtensions() {
    return [
      { columnName: 'row_num', align: 'right' },
      { columnName: 'id', align: 'right' },
      { columnName: 'insert_date', align: 'right' },
      { columnName: 'lic_update', align: 'right' },
      { columnName: 'l_date_insert', align: 'right' },
      // { columnName: 'u_is_admin', align: 'right' },
      // { columnName: 'u_is_reseller', align: 'right' },
      // { columnName: 'u_is_gas_specialist', align: 'right' },
      { columnName: 'l_ip_addr', align: 'right' },
      { columnName: 'l_sw_ver', align: 'right' },
    ]
  }
  getTableSortingStateColumnExtensions() {
    return [
      { columnName: 'row_num',        sortingEnabled: false },
      { columnName: 'lic_options',    sortingEnabled: false },
      { columnName: 'l_geo',          sortingEnabled: false },
      { columnName: 'u_user_type',    sortingEnabled: false },
    ]
  }
  getTableFilteringStateColumnExtensions() {
    return [
      { columnName: 'row_num',        filteringEnabled: false },
      { columnName: 'id',             filteringEnabled: false },
      { columnName: 'insert_date',    filteringEnabled: false },
      { columnName: 'lic_update',     filteringEnabled: false },
      { columnName: 'l_date_insert',  filteringEnabled: false },
      { columnName: 'lic_options',    filteringEnabled: false },
      { columnName: 'l_geo',          filteringEnabled: false },
    ]
  }
}
